import validate from "/builds/andy.c/gsn-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import _1_45redirect_45global from "/builds/andy.c/gsn-frontend/middleware/1.redirect.global.ts";
import dual_45token_45global from "/builds/andy.c/gsn-frontend/middleware/dual-token.global.ts";
import language_45manager_45global from "/builds/andy.c/gsn-frontend/middleware/language-manager.global.ts";
import manifest_45route_45rule from "/builds/andy.c/gsn-frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _1_45redirect_45global,
  dual_45token_45global,
  language_45manager_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}